/**
 * This context handles the global mute state of the entire app. It is tied to the Global Mute button, Pomodoro Timer,
 * Spaces Sound, Soundboard widget, and Rooms video chat audio
 */
import React, { createContext, useContext } from "react";

export type GlobalAudioContextType = {
    masterVolume: number;
    setMasterVolume: (volume: number) => void;
};

export const GlobalAudioContext: React.Context<GlobalAudioContextType> = createContext<GlobalAudioContextType>({
    masterVolume: 0,
    setMasterVolume: () => {},
});

export const useGlobalAudioContext = () => useContext(GlobalAudioContext);

export default GlobalAudioContext;
